// Socket
export const SOCKET_EMIT = 'SOCKET_EMIT';
export const UPDATE_LOCALE = 'UPDATE_LOCALE';
export const UPDATE_NAMESPACE = 'UPDATE_NAMESPACE';
export const UPDATE_SOCKET_STATE = 'UPDATE_SOCKET_STATE';
export const SOCKET_DISCONNECTED = 'SOCKET_DISCONNECTED';
// Authentication
export const AUTH_RETURN_TOKEN = 'AUTH_RETURN_TOKEN';
export const AUTH_INVALID_RETURN = 'AUTH_INVALID_RETURN';
export const AUTH_LOGIN_RETURN = 'AUTH_LOGIN_RETURN';
export const AUTH_LOG_OUT = 'AUTH_LOG_OUT';
export const GET_USER_INFO_RETURN = 'GET_USER_INFO_RETURN';
export const GET_PUBLIC_IP = 'GET_PUBLIC_IP';
export const RESET_TOKEN_RETURN = 'RESET_TOKEN_RETURN';
export const RENEW_API_TOKEN_RETURN = 'RENEW_API_TOKEN_RETURN';
// Streaming
// export const LIST_DEVICE_RETURN = 'LIST_DEVICE_RETURN';
export const DEVICE_CHANGE_STATE_RETURN = 'DEVICE_CHANGE_STATE_RETURN';
export const DEVICES_MAP_RETURN = 'DEVICES_MAP_RETURN';
export const REMOVE_DEVICE_RETURN = 'REMOVE_DEVICE_RETURN';
export const LIST_STATE_CAMERA_RETURN = 'LIST_STATE_CAMERA_RETURN';
export const LIST_STATE_GATEWAY_RETURN = 'LIST_STATE_GATEWAY_RETURN';
export const GATEWAY_UPDATE_INFO_RETURN = 'GATEWAY_UPDATE_INFO_RETURN';
export const CAMERA_UPDATE_INFO_RETURN = 'CAMERA_UPDATE_INFO_RETURN';
export const UPDATE_DEVICE_RETURN = 'UPDATE_DEVICE_RETURN';
export const SEARCH_DEVICE_BY_NAME_RETURN = 'SEARCH_DEVICE_BY_NAME_RETURN';
export const CREATE_STREAM = 'CREATE_STREAM';
export const START_STREAM_MONITOR = 'START_STREAM_MONITOR';
export const START_STREAM_MONITOR_FAILURE = 'START_STREAM_MONITOR_FAILURE';
export const REMOVE_START_STREAM_MONITOR_FAILURE = 'REMOVE_START_STREAM_MONITOR_FAILURE';
export const REMOVE_STREAM = 'REMOVE_STREAM';
export const CREATE_RTSP_STREAM = 'CREATE_RTSP_STREAM';
export const RECONNECT_STREAM = 'RECONNECT_STREAM';
export const WATCH_STREAM = 'WATCH_STREAM';
export const START_STREAM = 'START_STREAM';
export const END_STREAM = 'END_STREAM';
export const END_STREAM_ULTRA_FAST = 'END_STREAM_ULTRA_FAST';
export const UPDATE_STREAM_INFO = 'UPDATE_STREAM_INFO';
export const CLEAR_STREAM = 'CLEAR_STREAM';
export const REQUIRE_ACTIVE_DEVICE_RETURN = 'REQUIRE_ACTIVE_DEVICE_RETURN';
export const CHECK_FACE_TERMINAL_RETURN = 'CHECK_FACE_TERMINAL_RETURN';
export const CHECK_EXTERNAL_DEVICE_RETURN = 'CHECK_EXTERNAL_DEVICE_RETURN';
export const REQUIRE_ADD_DEVICE_RETURN = 'REQUIRE_ADD_DEVICE_RETURN';
export const CHECK_STREAM_RETURN = 'CHECK_STREAM_RETURN';
export const CLEAR_STREAM_RETURN = 'CLEAR_STREAM_RETURN';
export const CHECK_RTSP_STREAM_RETURN = 'CHECK_RTSP_STREAM_RETURN';
export const SCAN_STREAM_RETURN = 'SCAN_STREAM_RETURN';
export const ADD_EXTERNAL_DEVICE_RETURN = 'ADD_EXTERNAL_DEVICE_RETURN';
export const LIST_USER_SHARE_DEVICE_RETURN = 'LIST_USER_SHARE_DEVICE_RETURN';
export const LIST_GROUP_ACCOUNT_BY_DEVICE_GROUP_BY_PAGE_RETURN =
  'LIST_GROUP_ACCOUNT_BY_DEVICE_GROUP_BY_PAGE_RETURN';
export const LIST_DEVICE_AND_SHARE_EXTEND_RETURN =
  'LIST_DEVICE_AND_SHARE_EXTEND_RETURN';
export const UN_SHARE_PERMISSION_USER_RETURN =
  'UN_SHARE_PERMISSION_USER_RETURN';

export const CLEAR_LIST_ALL_DEVICE_BY_GROUP = 'CLEAR_LIST_ALL_DEVICE_BY_GROUP';

export const LIST_CAMERA_BY_PAGE_RETURN = 'LIST_CAMERA_BY_PAGE_RETURN';
export const RESET_CAMERA_BY_PAGE_RETURN = 'RESET_CAMERA_BY_PAGE_RETURN';
export const LIST_GATEWAY_BY_PAGE_RETURN = 'LIST_GATEWAY_BY_PAGE_RETURN';
export const GET_DEVICE_INFO_EXTRA_RETURN = 'GET_DEVICE_INFO_EXTRA_RETURN';

export const SHARE_PERMISSION_USER = 'SHARE_PERMISSION_USER';
export const LIST_CAMERA_STORAGE_RETURN = 'LIST_CAMERA_STORAGE_RETURN';
export const RESET_CAMERA_STORAGE_RETURN = 'RESET_CAMERA_STORAGE_RETURN';
export const GENERATE_LINK_STORAGE_FILE_RETURN =
  'GENERATE_LINK_STORAGE_FILE_RETURN';

export const STATISTIC_DEVICE_STATUS_RETURN = 'STATISTIC_DEVICE_STATUS';
export const UPDATE_NOTIFICATION_DEVICE_ON_MAPS =
  'UPDATE_NOTIFICATION_DEVICE_ON_MAPS';
export const AUTO_REMOVE_NOTIFY_DEVICE_ON_MAP =
  'AUTO_REMOVE_NOTIFY_DEVICE_ON_MAP';

///////////////////////////
export const SEARCH_CONTACT_RETURN = 'SEARCH_CONTACT_RETURN';

///////////////////////////
export const LIST_NOTIFICATION_RETURN = 'LIST_NOTIFICATION_RETURN';
export const NEW_NOTIFICATION_RETURN = 'NEW_NOTIFICATION_RETURN';
export const RESET_TOTAL_UNREAD_NOTIFICATION_RETURN =
  'RESET_TOTAL_UNREAD_NOTIFICATION_RETURN';
export const NEW_NOTIFICATION_DETAIL_RETURN = 'NEW_NOTIFICATION_DETAIL_RETURN';
export const UPDATE_NOTIFICATION_RETURN = 'UPDATE_NOTIFICATION_RETURN';
export const MARK_READ_NOTIFICATION_RETURN = 'MARK_READ_NOTIFICATION_RETURN';
export const FILTER_NOTIFICATION_RETURN = 'FILTER_NOTIFICATION_RETURN';

///////////////////////////
export const LIST_SERVICE_RETURN = 'LIST_SERVICE_RETURN';
export const LIST_SERVICE_BY_DEVICE_SERIAL_RETURN =
  'LIST_SERVICE_BY_DEVICE_SERIAL_RETURN';
export const LIST_DEVICE_BY_SERVICE_ID_RETURN =
  'LIST_DEVICE_BY_SERVICE_ID_RETURN';
export const LIST_TARGET_BY_SERVICE_ID_RETURN =
  'LIST_TARGET_BY_SERVICE_ID_RETURN';
export const LIST_DEVICE_ACTIVE_SERVICE_ID_RETURN =
  'LIST_DEVICE_ACTIVE_SERVICE_ID_RETURN';
export const LIST_TARGET_ACTIVE_SERVICE_ID_RETURN =
  'LIST_TARGET_ACTIVE_SERVICE_ID_RETURN';
export const GET_LICENSE_INFO_SERVICE_RETURN =
  'GET_LICENSE_INFO_SERVICE_RETURN';
export const ACTIVE_LICENSE_SERVICE_RETURN = 'ACTIVE_LICENSE_SERVICE_RETURN';
export const CANCEL_LICENSE_SERVICE_RETURN = 'CANCEL_LICENSE_SERVICE_RETURN';

///////////////////////////
export const LIST_ACCOUNT_BY_NAMESPACE_RETURN =
  'LIST_ACCOUNT_BY_NAMESPACE_RETURN';
export const LIST_ACCOUNT_BY_NAMESPACE_BY_PAGE_RETURN =
  'LIST_ACCOUNT_BY_NAMESPACE_BY_PAGE_RETURN';
export const LIST_DETAIL_ROLE_OF_CUSTOMER_RETURN =
  'LIST_DETAIL_ROLE_OF_CUSTOMER_RETURN';
export const LIST_NAMESPACE_RETURN = 'LIST_NAMESPACE_RETURN';
export const LIST_ACTION_LOG_BY_NAMESPACE_RETURN =
  'LIST_ACTION_LOG_BY_NAMESPACE_RETURN';
///////////////////////////
export const ADD_WHITE_LIST_IP_RETURN = 'ADD_WHITE_LIST_IP_RETURN';
export const LIST_WHITE_LIST_IP_BY_NAMESPACE_RETURN =
  'LIST_WHITE_LIST_IP_BY_NAMESPACE_RETURN';
export const DELETE_WHITE_LIST_IP_RETURN = 'DELETE_WHITE_LIST_IP_RETURN';
export const ADD_MEMBER_TO_NAMESPACE_RETURN = 'ADD_MEMBER_TO_NAMESPACE_RETURN';
export const UPDATE_MEMBER_TO_NAMESPACE_RETURN =
  'UPDATE_MEMBER_TO_NAMESPACE_RETURN';
export const REMOVE_MEMBER_TO_NAMESPACE_RETURN =
  'REMOVE_MEMBER_TO_NAMESPACE_RETURN';

export const UPDATE_PASSWORD_MEMBER_TO_NAMESPACE_RETURN =
  'UPDATE_PASSWORD_MEMBER_TO_NAMESPACE_RETURN';

/////////////////////////
export const GET_SUMARY_CAMERA_RETURN = 'GET_SUMARY_CAMERA_RETURN';
export const GET_LIST_LICENSE_BY_NAMESPACE = 'GET_LIST_LICENSE_BY_NAMESPACE';
export const GET_LIST_DEVICE_GROUP = 'GET_LIST_DEVICE_GROUP';
export const GET_DEVICE_GROUP_BY_ID = 'GET_DEVICE_GROUP_BY_ID';
export const GET_LIST_DEVICE_GROUP_BY_PAGE = 'GET_LIST_DEVICE_GROUP_BY_PAGE';
export const LIST_DEVICE_BY_DEVICE_GROUP_ID_RETURN =
  'LIST_DEVICE_BY_DEVICE_GROUP_ID_RETURN';
export const ADD_DEVICE_TO_GROUP = 'ADD_DEVICE_TO_GROUP';
export const UPDATE_DEVICE_TO_GROUP = 'UPDATE_DEVICE_TO_GROUP';
export const LIST_DEVICE_SELECT = 'LIST_DEVICE_SELECT';
export const CLEAR_LIST_DEVICE_SELECT = 'CLEAR_LIST_DEVICE_SELECT';
export const DELETE_DEVICE_TO_GROUP = 'DELETE_DEVICE_TO_GROUP';

export const LIST_CAMERA_DATE = 'LIST_CAMERA_DATE';
///////////////////////////
export const ADD_WHITE_LIST_DEVICE_RETURN = 'ADD_WHITE_LIST_DEVICE_RETURN';
export const LIST_WHITE_LIST_DEVICE_BY_NAMESPACE_RETURN =
  'LIST_WHITE_LIST_DEVICE_BY_NAMESPACE_RETURN';
export const DELETE_WHITE_LIST_DEVICE_RETURN =
  'DELETE_WHITE_LIST_DEVICE_RETURN';
///////////////////////////
export const LIST_GROUP_MEMBER_RETURN = 'LIST_GROUP_MEMBER_RETURN';
export const ADD_GROUP_MEMBER_RETURN = 'ADD_GROUP_MEMBER_RETURN';
export const UPDATE_GROUP_MEMBER_RETURN = 'UPDATE_GROUP_MEMBER_RETURN';
export const DELETE_GROUP_MEMBER_RETURN = 'DELETE_GROUP_MEMBER_RETURN';
///////////////////////////
export const LIST_ACCOUNT_GROUP_MEMBER_RETURN =
  'LIST_ACCOUNT_GROUP_MEMBER_RETURN';
export const CLEAR_LIST_ACCOUNT_GROUP_MEMBER =
  'CLEAR_LIST_ACCOUNT_GROUP_MEMBER';
export const ADD_ACCOUNT_GROUP_MEMBER_RETURN =
  'ADD_ACCOUNT_GROUP_MEMBER_RETURN';
export const DELETE_ACCOUNT_GROUP_MEMBER_RETURN =
  'DELETE_ACCOUNT_GROUP_MEMBER_RETURN';
export const LIST_GROUP_BY_PARENT_GROUP_RETURN =
  'LIST_GROUP_BY_PARENT_GROUP_RETURN';
export const CLEAR_LIST_GROUP_BY_PARENT_GROUP =
  'CLEAR_LIST_GROUP_BY_PARENT_GROUP';
export const CHECK_REMOVE_GROUP_RETURN = 'CHECK_REMOVE_GROUP_RETURN';

///////////////////////////
export const SHARE_PERMISSION_GROUP_RETURN = 'SHARE_PERMISSION_GROUP_RETURN';
export const DELETE_SHARE_PERMISSION_GROUP_RETURN =
  'DELETE_SHARE_PERMISSION_GROUP_RETURN';
export const UPDATE_SHARE_PERMISSION_USER_RETURN =
  'UPDATE_SHARE_PERMISSION_USER_RETURN';
export const GET_DEVICE_CONTACT_INFO_RETURN = 'GET_DEVICE_CONTACT_INFO_RETURN';
export const LIST_ALERT_RETURN = 'LIST_ALERT_RETURN';
export const STATISTIC_ACTION_LOG_BY_NAMESPACE_RETURN =
  'STATISTIC_ACTION_LOG_BY_NAMESPACE_RETURN';
///////////////////////////
export const CHECK_LDAP_ACCOUNT_RETURN = 'CHECK_LDAP_ACCOUNT_RETURN';
export const CHECK_AUTHENTICATION_TYPE = 'CHECK_AUTHENTICATION_TYPE';
export const AUTHENTICATION_LDAP_RETURN = 'AUTHENTICATION_LDAP_RETURN';
export const CONFIGURATION_SERVICE_RETURN = 'CONFIGURATION_SERVICE_RETURN';
export const REPORT_ACTION_LOG_RETURN = 'REPORT_ACTION_LOG_RETURN';
///////////////////////////
export const REQUEST_UPLOAD_FILE = 'REQUEST_UPLOAD_FILE';
export const UPLOAD_STORAGE_FILE = 'UPLOAD_STORAGE_FILE';
export const RESET_UPLOAD_FILE = 'RESET_UPLOAD_FILE';
export const REMOVE_STORAGE_FILE_RETURN = 'REMOVE_STORAGE_FILE_RETURN';
export const LIST_STORAGE_FILE_BY_TAG = 'LIST_STORAGE_FILE_BY_TAG';
export const SET_LIST_STORAGE_FILE_BY_TAG = 'SET_LIST_STORAGE_FILE_BY_TAG';
export const UPDATE_TAGS_STORAGE_FILE = 'UPDATE_TAGS_STORAGE_FILE';
export const SET_PLAY_VIDEO_AT_PAGE = 'SET_PLAY_VIDEO_AT_PAGE';
export const LIST_CAMERA_BY_STATE = 'LIST_CAMERA_BY_STATE';
export const LIST_GATEWAY_BY_STATE = 'LIST_GATEWAY_BY_STATE';

export const SET_OPEN_UPLOAD_FILES_DIALOG = 'SET_OPEN_UPLOAD_FILES_DIALOG';
export const SET_UPLOAD_FILES_CAMERA = 'SET_UPLOAD_FILES_CAMERA';
export const SET_UPLOAD_FILES_DATE = 'SET_UPLOAD_FILES_DATE';
export const SET_UPLOAD_FILES_OLD_VIDEOS = 'SET_UPLOAD_FILES_OLD_VIDEOS';

export const SET_LIST_NOTIFICATION = 'SET_LIST_NOTIFICATION';
export const DELETE_LIST_NOTIFICATION = 'DELETE_LIST_NOTIFICATION';

export const LIST_DEVICE_BY_USER_RETURN = 'LIST_DEVICE_BY_USER_RETURN';
export const LIST_DEVICE_GROUP_BY_USER_RETURN = 'LIST_DEVICE_GROUP_BY_USER_RETURN';

export const UPDATE_STATE_DEVICES_RETURN = 'UPDATE_STATE_DEVICES_RETURN';

export const SET_PINNED_CAMERAS_MODE_RETURN = 'SET_PINNED_CAMERAS_MODE_RETURN';

export const LIST_PLACE_BY_PAGE = 'LIST_PLACE_BY_PAGE';
export const ADD_PLACE_RETURN = 'ADD_PLACE_RETURN';
export const REMOVE_PLACE_RETURN = 'REMOVE_PLACE_RETURN';

export const REQUEST_MAKE_CALL_RETURN = 'REQUEST_MAKE_CALL_RETURN';
export const CHANGE_DIAL_PAD_DATA = 'CHANGE_DIAL_PAD_DATA';

export const GENERATE_LINK_STORAGE_FILE_BY_TIME_RETURN =
  'GENERATE_LINK_STORAGE_FILE_BY_TIME_RETURN';
export const POPUP_VIDEO_STORAGE_FILE_BY_TIME_RETURN =
  'POPUP_VIDEO_STORAGE_FILE_BY_TIME_RETURN';
export const GET_LIST_DEVICE_GROUP_BY_PARENT_DEVICE_GROUP_SUCCESS =
  'GET_LIST_DEVICE_GROUP_BY_PARENT_DEVICE_GROUP_SUCCESS';
export const GET_LIST_DEVICE_GROUP_BY_PARENT_DEVICE_GROUP_RETURN =
  'GET_LIST_DEVICE_GROUP_BY_PARENT_DEVICE_GROUP_RETURN';
export const GET_LIST_DEVICE_GROUP_BY_PARENT_DEVICE_GROUP_FAIL =
  'GET_LIST_DEVICE_GROUP_BY_PARENT_DEVICE_GROUP_FAIL';

export const GENERATE_SHORT_TOKEN = 'GENERATE_SHORT_TOKEN';
export const GENERATE_SHORT_TOKEN_RETURN = 'GENERATE_SHORT_TOKEN_RETURN';
export const SET_SHOW_CRITICAL = 'SET_SHOW_CRITICAL';
export const GET_LIST_GPS_LOCATION = 'GET_LIST_GPS_LOCATION';
export const GET_LIST_SPEAKER_SIP = 'GET_LIST_SPEAKER_SIP';
export const GET_REPORT_BY_NAMESPACE_RETURN = 'GET_REPORT_BY_NAMESPACE_RETURN';
export const GET_REPORT_BY_NAMESPACE_SUCCESS =
  'GET_REPORT_BY_NAMESPACE_SUCCESS';
export const UPDATE_DEVICE_REPORTS_CAUSE_RETURN =
  'UPDATE_DEVICE_REPORTS_CAUSE_RETURN';
export const UPDATE_DEVICE_REPORTS_CAUSE_SUCCESS =
  'UPDATE_DEVICE_REPORTS_CAUSE_SUCCESS';
export const DETECT_OBJECT = 'DETECT_OBJECT';
export const DETECT_PERSON = 'DETECT_PERSON';
export const DETECT_FACE = 'DETECT_FACE';
export const DETECT_WEAPON = 'DETECT_WEAPON';
export const DETECT_FIRE = 'DETECT_FIRE';
export const DETECT_VIRTUAL_WALL = 'DETECT_VIRTUAL_WALL';
export const RECOGNITION_FACE = 'RECOGNITION_FACE';
export const DETECT_EVENT_COMMON = 'DETECT_EVENT_COMMON';
export const CLEAR_ALERT = 'CLEAR_ALERT';
export const TOGGLE_SMART_MODE = 'TOGGLE_SMART_MODE';
export const SET_CAMERA_SERIALS = 'SET_CAMERA_SERIALS';
export const CLEAR_CAMERA_SERIALS = 'CLEAR_CAMERA_SERIALS';
export const SET_FILTERING_ALERTS = 'SET_FILTERING_ALERTS';
export const LIST_DATA_SEARCH_RETURN = 'LIST_DATA_SEARCH_RETURN';

//////// MILESTONE /////////////
export const START_SESSION_STREAM_MILESTONE = 'START_SESSION_STREAM_MILESTONE'
export const UPDATE_ANSWER_SDP_MILESTONE = 'UPDATE_ANSWER_SDP_MILESTONE'
export const UPDATE_CANDIDATE_WEB_MILESTONE = 'UPDATE_CANDIDATE_WEB_MILESTONE'
export const UPDATE_CANDIDATES_MILESTONE = 'UPDATE_CANDIDATES_MILESTONE'
